module.exports = {
  replace: true,
  props: ['page', 'item'],
  computed: {
    index: function () {
      if (this.page) {
        return (this.page - 1) * 30 + this.$index + 1
      }
    },
    href: function () {
      return this.item.url || ('#/item/' + this.item.id)
    },
    showInfo: function () {
      return this.item.type === 'story' || this.item.type === 'poll'
    },
    showDomain: function () {
      return this.item.type === 'story'
    }
  }
}


/*****************
 ** WEBPACK FOOTER
 ** ../vue-loader/lib/selector.js?script!./src/components/item.vue
 ** module id = 89
 ** module chunks = 0
 **/